// src/hooks/useChapters.js
import { useMemo } from "react";
import { server2 } from "../constant/config";
import { getChapters } from "../constant/urls";
import { useFetchData } from "./useFetchData";

export const useChapters = (board, classId, subjectId) => {
  const enabled = Boolean(board && classId && subjectId);
  const { data, loading, error, refetch } = useFetchData(
    enabled ? `${server2}${getChapters}` : null,
    {
      enabled,
      dependencies: [board, classId, subjectId],
      transform: (res) => {
        const chapters = res?.details?.chapters || [];
        return chapters.filter(
          (ch) =>
            ch.class_id?.toString() === classId?.toString() &&
            ch.board_id?.toString() === board?.toString() &&
            ch.subject_id?.toString() === subjectId?.toString()
        );
      },
    }
  );

  const chapters = useMemo(() => data || [], [data]);

  return { chapters, loading, error, refetch };
};
